export default {
  setList(state, list) {
    state.list = [...state.list, ...list];
  },

  setDetail(state, detail) {
    state.detail = detail;
  },

  initList(state) {
    state.page = 1;
    state.totalPage = 2;
    state.list = [];
  },

  setPage(state, page = 1) {
    state.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.totalPage = totalPage;
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setRecentSearchedList(state, data) {
    let list = [...state.recentSearchedList];
    if (
      state.recentSearchedList.filter(
        (elem) => elem.address === data.address && elem.addressDetail === data.addressDetail
      ).length === 0
    ) {
      list = [data, ...state.recentSearchedList];
    }
    list.slice(0, 10);

    state.recentSearchedList = list;
  },

  spliceByIndex(state, index) {
    state.recentSearchedList.splice(index, 1);
  }
};
